import React from "react"
import { Box, Grid } from "@mui/material"
import { PrimaryText } from "../../ui/Text"
import { PRIMARY, SECONDARY, YELLOW } from "../../ui/Colors"
import NotificationsIcon from '@mui/icons-material/Notifications';

export const NotificationsInHeader = ({ setOpen, numberOfNotifications }: { setOpen: React.Dispatch<React.SetStateAction<Boolean>>, numberOfNotifications: number }) => {
    return (<Grid
        position="relative"
        onClick={() => setOpen(true)}
        sx={{ cursor: 'pointer', display: 'flex' }}
        id="openNotifications"
    >
        <NotificationsIcon
            fontSize="large"
            sx={{
                width: '2.5vw',
                height: '2.5vh',
                color: YELLOW,

                position: 'relative',
            }}
        />
        <Box
            sx={{
                cusror: "pointer",
                position: 'absolute',
                padding: 0.2,
                borderRadius: 30,
                width: 15,
                backgroundColor: SECONDARY,
                top: -4,
                right: -4,
                textAlign: "center"
            }}
        >
            <PrimaryText bold color={PRIMARY} style={{ fontSize: "12px !important" }}>
                {numberOfNotifications}
            </PrimaryText>
        </Box>
    </Grid >)
}